<template>
  <div class="tooltip hide-for-print">
    <svg @click.stop.prevent="clickTooltip()" width="12" height="12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 11.32 11.32">
      <path class="cls-2" d="M5.66,10.82a5.16,5.16,0,1,1,5.16-5.16A5.17,5.17,0,0,1,5.66,10.82Z"/><path class="cls-3" d="M5.48,7.25a.59.59,0,1,0,.57.6A.57.57,0,0,0,5.48,7.25Z"/><path class="cls-3" d="M5.59,3a2.07,2.07,0,0,0-1.14.32l-.08.06.27.72L4.78,4a1.2,1.2,0,0,1,.68-.21c.27,0,.59.1.59.52a1.55,1.55,0,0,1-.49.94,1.83,1.83,0,0,0-.49,1.38l0,.31h.83V6.6a1.36,1.36,0,0,1,.4-1A2.13,2.13,0,0,0,7,4.21,1.23,1.23,0,0,0,5.59,3Z"/>
    </svg>
  </div>
</template>

<script>
import {EventBus} from '@/event-bus.js'

export default {
  name: 'help-tooltip',
  props: {
    description: {},
    link: {
      default: false
    },
    followMouse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  destroyed () {
    EventBus.$emit('tooltip.hide')
  },
  methods: {
    clickTooltip () {
      this.showTooltip()
    },
    showTooltip () {
      EventBus.$emit('tooltip.show', {
        style: 'single',
        label: this.description,
        followMouse: this.followMouse,
        link: this.link
      })
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.tooltip{
  display: inline-block;
  height: 12px;
  width: 12px;
}

.cls-1{opacity:0.47;}
.cls-2{fill:none;stroke:#9aa1a8;stroke-miterlimit:10;}
.cls-3{fill:#9aa1a8;}
</style>



// WEBPACK FOOTER //
// src/components/shared/misc/HelpTooltip.vue